import { config } from "config";
import { SetCarsPayload, DeliveryCarState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SelectOption } from "components/atoms/Select";

const default_page_size = config.PAGE_SIZE;
const initialState: DeliveryCarState = {
  cars: [],
  car: null,
  loading: true,
  exportCSVLoading: false,
  csvMessage: null,
  current_filters: {},
  deliveryCarOptions: [],
  filters: { page: 1, pageSize: default_page_size },
  refresh: 0,
  refreshLoader: false,
  totalCount: 0,
  carsAvailabilities: [],
};

export const deliveryCarSlice = createSlice({
  name: "deliveryCar",
  initialState,
  reducers: {
    setCarOptions: (state, action) => {
      state.deliveryCarOptions = action.payload;
    },
    clear: (state) => {
      state.deliveryCarOptions = [];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setExportCSVLoading: (state, action: PayloadAction<boolean>) => {
      state.exportCSVLoading = action.payload;
    },
    addCar: (state, action) => {
      state.cars.unshift(action.payload);
    },
    updateCar: (state, action) => {
      const { id, car } = action.payload;
      state.cars.every(({ _id }, i) => {
        if (id === _id) {
          state.cars[i] = car;
          return false;
        }
        return true;
      });
    },
    deleteCarById: (state, action) => {
      const id = action.payload;
      state.cars.every(({ _id }, i) => {
        if (id === _id) {
          state.totalCount -= 1;
          state.cars.splice(i, 1);
          return false;
        }
        return true;
      });
    },
    setCar: (state, action) => {
      state.car = action.payload;
    },
    setCars: (state, action: PayloadAction<SetCarsPayload>) => {
      const { Cars: items } = action.payload;
      state.cars = items;
    },
    setCarsAvailability: (state, action: PayloadAction<any[]>) => {
      state.carsAvailabilities = action.payload;
    },

    setTotalCount: (state, action: PayloadAction<{ totalCount: number }>) => {
      const { totalCount } = action.payload;
      state.totalCount = totalCount;
    },

    setPage: (state, action: PayloadAction<{ page: number }>) => {
      const { page } = action.payload;
      state.filters.page = page;
      state.refresh += 1;
      state.refreshLoader = true;
    },
    resetPage: (state) => {
      state.filters.page = 1;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setCurrentFilters: (state, action) => {
      state.current_filters = action.payload;
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
      state.current_filters = initialState.current_filters;
    },
    setCsvMessage: (
      state,
      action: PayloadAction<{
        message: string;
        type: "success" | "error" | "warning" | "info";
      } | null>
    ) => {
      state.csvMessage = action.payload;
    },
  },
});

const deliveryCarReducer = deliveryCarSlice.reducer;

export const deliveryCarActions = deliveryCarSlice.actions;
export default deliveryCarReducer;
